'use strict';

angular.module('mean.databases').factory('PayPeriodService', ['$filter', 'toaster', 'aceUtils', 'tradeCodeService',
    function($filter, toaster, aceUtils, tradeCodeService) {
        var payperiods = [];
        var payToday = {};
        var strFormat = 'DD MMM YYYY';

        var incrementPayPeriod = function(start, end, period) {
            if(period === 'weekly') {
                end.add(7, 'days');
            } else if(period === 'biweekly') {
                end.add(14, 'days');
            }

            var startDate;

            if(period === 'weekly') {
                startDate = moment(end).subtract(6, 'days');
            } else if(period === 'biweekly') {
                startDate = moment(end).subtract(13, 'days');
            }

            startDate.second(0);
            startDate.minute(0);
            startDate.hour(0);
            end.second(59);
            end.minute(59);
            end.hour(23);

            payperiods.push({
                start: moment(startDate),
                end: moment(end),
                string: startDate.format(strFormat) + ' - ' + end.format(strFormat)
            });

            if(start <= payToday && payToday <= end) {
                start = moment(startDate);
                return -1;
            }
            else
              return 0;
        };

        var setPayPeriods = function(users_trade_account) {
            var company_code = aceUtils.padDigits(users_trade_account.company_code, 3);
            var trade_code = users_trade_account.trade_code?
                    users_trade_account.trade_code:
                    tradeCodeService.getCode(users_trade_account.trade)

            if(!users_trade_account.payroll_end_date || !users_trade_account.payroll_period) {
                toaster.pop('error', 'No Payroll Settings', 'Please set payroll settings in Company Admin');
                return;
            }

            var payStartDate = moment(users_trade_account.payroll_end_date).add(1, 'day');
            var payEndDate = moment(users_trade_account.payroll_end_date).add(1, 'day');
            if(users_trade_account.payroll_period === 'weekly') {
                payEndDate.add(6, 'day');
            } else if(users_trade_account.payroll_period === 'biweekly') {
                payEndDate.add(13, 'day');
            }

            payToday = moment();

            payperiods = [];

            while(incrementPayPeriod(payStartDate, payEndDate,
                users_trade_account.payroll_period) !== -1) {
            }

            return payperiods;
        };

        var getCurrent = function(users_trade_account) {
            var periods = setPayPeriods(users_trade_account);
            periods.reverse();
            var ret_val = null;
            console.log('looking for the pay period');

            var today = new moment();
            for(var i=0; i<periods.length; i++) {
                // if(today.isBetween(periods[i].start, periods[i].end, 'days', '[]')) {
                //     console.log('found it');
                //     ret_val = periods[i];
                //     break;
                // }
                if(periods[i].start <= today && periods[i].end >= today) {
                    ret_val = periods[i];
                    break;
                }
            }

            return ret_val;
        }

        return {
            setPayPeriods: setPayPeriods,
            getCurrent: getCurrent
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/databases/public/services/pay-period-service.js